export default __webpack_public_path__ + "f84b476995a8496adce24ec672244eafc9a43686/5d23014a563dca4f7a3a15ddbb31830f.png";